export default class CreditApplyLateFeeItem {
    constructor(
      selectedLineItemIds,
      selectedAssignmentIds,
      creditMemoRequest,
      allItemsInTheSearchSetAreSelected,
      searchItem,
      creditPercentFee,
      creditPercentReimbursement
    ) {
      this.initialize(
        selectedLineItemIds,
        selectedAssignmentIds,
        creditMemoRequest,
        allItemsInTheSearchSetAreSelected,
        searchItem,
        creditPercentFee,
        creditPercentReimbursement
      );
    }
  
    async initialize(
      selectedLineItemIds,
      selectedAssignmentIds,
      creditMemoRequest,
      allItemsInTheSearchSetAreSelected,
      searchItem,
      creditPercentFee,
      creditPercentReimbursement,
    ) {
      this.SelectedLineItemIds = selectedLineItemIds;
      this.SelectedAssignmentIds = selectedAssignmentIds;
      this.CreditType = 'Credit Percent';
      this.CreditPercentFee = creditPercentFee;
      this.CreditPercentReimbursement = creditPercentReimbursement;
      this.CreditAmountFee = '';
      this.CreditAmountReimbursement = '';
      this.CreditMemoRequestId = creditMemoRequest.creditMemoRequestId;
      this.LineItemCreditAmount = creditMemoRequest.lineItemCreditAmount;
      this.CurrencyCode = creditMemoRequest.currencyCode;
      this.BaseFee = '';
      this.BaseReimbursement = '';
      this.NotSelectedCreditAmount = '';
      this.CreditAmountAfter = '';
      this.MaxInvoiceAmount = '';
      this.AllItemsInTheSearchSetAreSelected = allItemsInTheSearchSetAreSelected;
      this.SearchItem = searchItem;
      this.Action = -1;
    }
  }
  